var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"stickyelement",staticClass:"wl-sticky",class:{ 'wl-sticky--position-reset': _vm.isSticky }},[_c('div',{class:{ 'wl-sticky--issticky': _vm.isSticky },style:(_vm.cssStyles)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }